export default __webpack_public_path__ + "static/media/topcat1.67aa6189.png";